const DEFAULT_LLM_ROUTE = {
  verb: 'GET',
  path: '/v1/models',
  body: [],
};

const DEFAULT_AUTHORIZED_ROUTE = {
  verb: 'POST',
  path: '',
  body: [],
};

export function shouldIncludeBearerAuth(endpoint) {
  const authorizer_type = endpoint?.authorizer?.type;
  return authorizer_type && authorizer_type !== 'none';
}

export function getConnectCurlRoute(endpoint) {
  if (endpoint?.routes?.[0]) {
    return endpoint.routes[0];
  }

  if (endpoint?.llm) {
    return DEFAULT_LLM_ROUTE;
  }

  if (shouldIncludeBearerAuth(endpoint)) {
    return DEFAULT_AUTHORIZED_ROUTE;
  }

  return null;
}

export function buildCurlCommand(url, route, include_bearer_auth = false) {
  const parts = [
    `curl -X ${route.verb}`,
    '-H "Content-Type: application/json"',
  ];

  if (include_bearer_auth) {
    parts.push('-H "Authorization: Bearer <token>"');
  }

  if (route.body?.length) {
    const body = route.body
      .map((param) => `"${param.name}": ${param.type}`)
      .join(', ');
    parts.push(`-d '{${body}}'`);
  }

  parts.push(`${url}${route.path}`);

  return parts.join(' ');
}
